import { environment } from '@quartz-gov-legacy/environments/environment';

(function () {
    'use strict';

    angular
        .module('riskSelfAssessmentAssessControllers')
        .controller('RiskSelfAssessmentAssessSummaryController', Controller);

    Controller.$inject = ['$scope', '$state', '$stateParams', 'riskSelfAssessmentAssessService', 'govProcess', 'risksToAssess', 'criterias', 'authenticatedAssessorID', 'assessmentQuestions', 'exportService'];

    function Controller($scope, $state, $stateParams, riskSelfAssessmentAssessService, govProcess, risksToAssess, criterias, authenticatedAssessorID, assessmentQuestions, exportService) {
        var overallRatings = _.filter(criterias, {RiskLookupAssessmentTypeName: 'Overall'});
        var naRating       = {Color: 'default', Name: 'N/A'};

        if (!_.isArray(risksToAssess)) {
            return;
        }

        $scope.govProcess          = govProcess;
        $scope.risksToAssess       = risksToAssess;
        $scope.assessmentQuestions = assessmentQuestions;
        $scope.view                = {};
        $scope.ctrlCtxt            = {
            allRisksAssessed: areAllRisksAssessed(),
            preliminaryQuestionsAnswered: arePreliminaryQuestionsAnswered(),
            finalQuestionsAnswered: areFinalQuestionsAnswered()
        };

        // Init views
        if ($scope.ctrlCtxt.allRisksAssessed
            && $scope.ctrlCtxt.preliminaryQuestionsAnswered
            && $scope.ctrlCtxt.finalQuestionsAnswered
            && _.some(risksToAssess, {Assessment: {HasInitialAssessorSubmitted: false}})) {

            $scope.view.showSubmitAction = true;
        }

        if (_.every(risksToAssess, {Assessment: {HasInitialAssessorSubmitted: true}})) {
            $scope.view.showSubmittedAlert           = true;
            $scope.ctrlCtxt.haveAllRisksBeenAssessed = true;
        }

        // Assessor
        $scope.getAssessorId = function () {
            if (risksToAssess.length === 0) return;
            return risksToAssess[0].Risk.AssessorID;
        };

        // Continue assessment
        $scope.continueAssessment = function () {
            if (!$scope.ctrlCtxt.preliminaryQuestionsAnswered) {
                $scope.goToPreliminaryQuestions();
            } else if (!$scope.ctrlCtxt.allRisksAssessed) {
                $state.go('riskSelfAssessmentAssess.assessor.riskToAssess', {RiskID: risksToAssess[getRiskToAssessIndex()].Risk.RiskID});
            } else if (!$scope.ctrlCtxt.finalQuestionsAnswered) {
                $scope.goToFinalQuestions();
            }
        };

        // Get Computed overall Rating
        $scope.getComputedOverallRating = function (riskToAssess) {
            if (!riskToAssess.Assessment || !riskToAssess.Assessment.InitialComputedOverallCode) {
                return naRating;
            }

            return _.find(overallRatings, {Code: riskToAssess.Assessment.InitialComputedOverallCode});
        };


        // Poll export
        $scope.pollExport = function () {
          exportService.pollExport($scope.urlToExportSummaryReport(), {});
        };

        // Get Overall Rating
        $scope.getOverallRating = function (riskToAssess) {
            if (!riskToAssess.Assessment || !riskToAssess.Assessment.InitialOverallCode) {
                return naRating;
            }

            return _.find(overallRatings, {Code: riskToAssess.Assessment.InitialOverallCode});
        };

        // Go to Risk Assessment
        $scope.goToRiskAssessment = function (risk) {
            if ($scope.ctrlCtxt.haveAllRisksBeenAssessed) return;

            $state.go('riskSelfAssessmentAssess.assessor.riskToAssess', {RiskID: risk.RiskID});
        };

        $scope.goToPreliminaryQuestions = function() {
            $state.go('riskSelfAssessmentAssess.preliminaryQuestions');
        };

        $scope.goToFinalQuestions = function() {
            $state.go('riskSelfAssessmentAssess.finalQuestions');
        };

        $scope.urlToExportSummaryReport = function () {
            var url = environment.apiUrl + '/ReportPilot/api/RiskSelfAssessment/SummaryExportToReport';
            if (authenticatedAssessorID != null) {
                url = environment.apiUrl + '/ReportPilot/api/RiskSelfAssessment/Assessor@' + authenticatedAssessorID + '/SummaryExportToReport';
            }
            return url;
        };

        // Submit Assessment
        $scope.submitAssessment = function () {
            var assessorId = null;
            if (authenticatedAssessorID != null) {
                assessorId = authenticatedAssessorID;
            }
            return riskSelfAssessmentAssessService
                .submit(assessorId)
                .then(function () {
                    $scope.view.showSubmitAction             = false;
                    $scope.view.showSubmittedAlert           = true;
                    $scope.ctrlCtxt.haveAllRisksBeenAssessed = true;
                });
        };

        // Go to Home
        $scope.goToHome = function () {
            $state.go('home', {UserItemPersonID: $stateParams.ItemPersonID});
        };

        // Helpers
        function getRiskToAssessIndex() {
            var riskIndex = _.findIndex(risksToAssess, function (risk) {
                return !risk.Assessment || !risk.Assessment.RiskAssessmentID;
            });

            return riskIndex;
        }

        function areAllRisksAssessed() {
            var riskIndex = getRiskToAssessIndex();

            if (riskIndex > -1) {
                return false;
            }

            return riskIndex === -1;
        }

        function arePreliminaryQuestionsAnswered() {
            if (!$scope.assessmentQuestions) return true;

            return riskSelfAssessmentAssessService.isQuestionValid($scope.assessmentQuestions.RiskAssessmentQuestions[0]);
        }

        function areFinalQuestionsAnswered() {
            if (!$scope.assessmentQuestions) return true;

            return riskSelfAssessmentAssessService.isQuestionValid($scope.assessmentQuestions.RiskAssessmentQuestions[1]);
        }
    }
})();
